import { createContext } from "react";
import { Version } from "../models/version";
import { SafeAreaModel } from "../models/safe-area-model";

export type AppContext = {
	version: Version | undefined;
	safeArea: SafeAreaModel;
};

export const AppContext = createContext<AppContext | null>(null);
